import { render, staticRenderFns } from "./form-agv-details.vue?vue&type=template&id=24690317&scoped=true&lang=pug&"
import script from "./form-agv-details.vue?vue&type=script&lang=js&"
export * from "./form-agv-details.vue?vue&type=script&lang=js&"
import style0 from "./form-agv-details.vue?vue&type=style&index=0&id=24690317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24690317",
  null
  
)

export default component.exports